import React, {useEffect, useState} from "react";
import EnterpriseComponent from "../../eoec/ec/EnterpriseComponent";
import EventBus from "../../util/EventBus";
import {Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography} from "@mui/material";
import css_buttons from "../Common/css/CCButton.module.scss";
import CCButton from "../Common/CCButton";
import { Info } from "@mui/icons-material";
import * as validators from "../../util/Validators";
import {updateObject} from "../../util/utility";


export default function ProjectPlanPhaseSubmitForApproval(props: any) {
    const [backgroundOperation, setBackgroundOperation] = useState<boolean>(false);
    const [controls, setControls] = useState<any>({"Justification": {"value": ""}});

    function enterpriseComponentUpdateStartedListener(ec: EnterpriseComponent) {
        setBackgroundOperation(true)
    }

    function enterpriseComponentUpdateCompletedListener(ec: EnterpriseComponent) {
        const projectPlanPhaseEnterpriseComponent: EnterpriseComponent = props.enterpriseComponent.getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase")!

        if (ec.serialNumber === projectPlanPhaseEnterpriseComponent.serialNumber) {
            const projectPlanPhaseApprovalEnterpriseComponent: EnterpriseComponent = props.enterpriseComponent.getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhaseApproval")!
            projectPlanPhaseApprovalEnterpriseComponent.setAttributeValue("Submit", true)
            projectPlanPhaseApprovalEnterpriseComponent.setAttributeValue("ProjectPlanPhaseUSID", props.enterpriseComponent.getAttributeValue("USID"))
            projectPlanPhaseApprovalEnterpriseComponent.executeUpdate();
        } else {
            EventBus.components.emit("project-plan-phase-submit-for-approval-save");
        }
    }

    useEffect(() => {
        const projectPlanPhaseEnterpriseComponent: EnterpriseComponent = props.enterpriseComponent.getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase")!
        const projectPlanPhaseApprovalEnterpriseComponent: EnterpriseComponent = props.enterpriseComponent.getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhaseApproval")!

        projectPlanPhaseEnterpriseComponent.addUpdateStartedListener(enterpriseComponentUpdateStartedListener);
        projectPlanPhaseEnterpriseComponent.addUpdateCompletedListener(enterpriseComponentUpdateCompletedListener);

        projectPlanPhaseApprovalEnterpriseComponent.addUpdateStartedListener(enterpriseComponentUpdateStartedListener);
        projectPlanPhaseApprovalEnterpriseComponent.addUpdateCompletedListener(enterpriseComponentUpdateCompletedListener);

        return () => {
            projectPlanPhaseEnterpriseComponent.removeUpdateStartedListener(enterpriseComponentUpdateStartedListener);
            projectPlanPhaseEnterpriseComponent.removeUpdateCompletedListener(enterpriseComponentUpdateCompletedListener);

            projectPlanPhaseApprovalEnterpriseComponent.removeUpdateStartedListener(enterpriseComponentUpdateStartedListener);
            projectPlanPhaseApprovalEnterpriseComponent.removeUpdateCompletedListener(enterpriseComponentUpdateCompletedListener);
        }

    }, [props.enterpriseComponent]);

    function onCancelHandler() {
        EventBus.components.emit("project-plan-phase-submit-for-approval-cancel");
    }

    function updateHandler() {
        const projectPlanPhaseEnterpriseComponent: EnterpriseComponent = props.enterpriseComponent.getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase")!
        projectPlanPhaseEnterpriseComponent.executeUpdate();
    }

    function justificationChangedHandler(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        let check = validators.NoSpecialCharacters(event.target.value);

        const updatedFormElement = updateObject(controls["Justification"], {
            value: event.target.value,
            touched: true,
            valid: check,
            helperText: null,
            invitationInProgress: false,
            userExistsInClinic: false,
            userExistsInProvider: false,
            userDoesNotExist: null,
            mainEmailVerifiedState: null,
            invitationSaved: false,
        });
        const updatedForm = updateObject(controls, {
            "Justification": updatedFormElement,
        });

        setControls(updatedForm);

        const projectPlanPhaseEnterpriseComponent: EnterpriseComponent = props.enterpriseComponent.getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase")!
        projectPlanPhaseEnterpriseComponent.setAttributeValue("Justification", event.target.value)
    }

    function updateView() {
        let buttonHandler = null;
        let objectDetailContent = null;

        if (!backgroundOperation) {
            let firstButtonHandlerContent = (
                <CCButton
                    className={css_buttons.redStandardButton}
                    onClick={onCancelHandler}>
                    Cancel
                </CCButton>
            );

            let secondButtonHandlerContent = (
                <CCButton
                    className={css_buttons.blueStandardButton}
                    animate={backgroundOperation}
                    onClick={() => updateHandler()}>
                    Save
                </CCButton>
            )

            buttonHandler = (
                <DialogActions style={{marginBottom: "10px", width: "96%"}}>
                    {firstButtonHandlerContent}
                    {secondButtonHandlerContent}
                </DialogActions>
            );
        }

        return (
            <>
                <Dialog open={true} scroll="body">
                    <DialogTitle>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                            <Typography style={{fontSize: "20px", fontWeight: 500, color: "#000000"}}>Submit For Approval:&nbsp;&nbsp;</Typography>
                            <Typography style={{fontSize: "20px", fontWeight: 500, color: "#A8A9AF"}}>{props.enterpriseComponent.getAttributeValue("Name")}</Typography>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <div style={{display: "flex", flexDirection: "column"}}>
                            <div style={{display: "flex", flexDirection: "row", margin: "20px 20px 20px 0"}}>
                                <div>
                                    <Info sx={{marginTop: "5px", width: "60px", height: "60px", color: "#F1C40F"}}/>
                                </div>
                                <div>
                                    <Typography style={{margin: "13px 0 0 6px", fontSize: "16px", fontWeight: 400, color: "#000000"}}>Some of the milestones associated to this phase are in the 'IN PROGRESS' state. To proceed, a justification must be given.</Typography>
                                </div>
                            </div>
                            <div style={{display: "flex", flexDirection: "row", margin: "0 20px 20px 0", width: "100%"}}>
                                <TextField
                                    key="Justification"
                                    margin="dense"
                                    fullWidth={true}
                                    helperText={"A value is required."}
                                    id="Justification"
                                    label="Justification *"
                                    onChange={(event) => justificationChangedHandler(event)}
                                    value={controls["Justification"].value}
                                    variant="outlined"
                                    slotProps={{
                                        input: {
                                        },
                                        inputLabel: {shrink: true}
                                    }}
                                />
                            </div>
                        </div>
                        {objectDetailContent}
                    </DialogContent>
                    {buttonHandler}
                </Dialog>
            </>
        );
    }

    return (
        <>
            {updateView()}
        </>
    )
}
